"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MissionFrequency = void 0;
var MissionFrequency;
(function (MissionFrequency) {
    MissionFrequency["ONCE_A_WEEK"] = "ONCE_A_WEEK";
    MissionFrequency["TWICE_A_WEEK"] = "TWICE_A_WEEK";
    MissionFrequency["MORE_THAN_TWICE_A_WEEK"] = "MORE_THAN_TWICE_A_WEEK";
})(MissionFrequency = exports.MissionFrequency || (exports.MissionFrequency = {}));
//# sourceMappingURL=MissionFrequency.js.map